module.exports = __webpack_public_path__ + "static/media/logo.598568a9.png";